// RTK Query freezes the data it returns, but these pages were written against
// axios responses and edit them in place (scenario attributes, phase mappings,
// allocation rows). Copy every response before it enters component state.
const mutableCopy = (value) =>
  value === undefined ? value : JSON.parse(JSON.stringify(value));

export default mutableCopy;
